module.exports = __webpack_public_path__ + "static/media/task.4e74d6df.svg";